module.exports = __webpack_public_path__ + "img/Home_Desktop_01.950843a1.jpg";